import React, { useEffect, useRef, useCallback, useState } from "react";
import { BrowserQRCodeReader } from "@zxing/browser";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import Navbar from "../components/ui/Navbar";

export default function QRScannerPage() {
  const videoRef = useRef(null);
  const controlsRef = useRef(null);
  const navigate = useNavigate();

  const [status, setStatus] = useState("Inicializando cámara…");

  // 🔍 Interpretación EXACTA de tu QR
  const interpretarQR = useCallback(
    (data) => {
      if (data.includes("/open/equipo/")) {
        const id = data.split("/open/equipo/")[1];
        setStatus("Equipo detectado");
        navigate(`/equipos/${id}`);
        return;
      }

      if (data.includes("/open/mobiliario/")) {
        const id = data.split("/open/mobiliario/")[1];
        setStatus("Mobiliario detectado");
        navigate(`/mobiliario/${id}`);
        return;
      }

      setStatus("QR no reconocido");
    },
    [navigate],
  );

  useEffect(() => {
    const reader = new BrowserQRCodeReader();

    // ⚡ Más intentos por segundo (más rápido)
    reader.timeBetweenDecodingAttempts = 100;

    setStatus("Solicitando acceso a la cámara…");

    reader
      .decodeFromConstraints(
        {
          video: {
            facingMode: { ideal: "environment" }, // 📱 cámara trasera
            width: { ideal: 640 }, // ⚡ resolución óptima
            height: { ideal: 480 },
          },
        },
        videoRef.current,
        (result, error) => {
          if (result) {
            // 🔥 detener el escaneo
            if (controlsRef.current) {
              controlsRef.current.stop();
            }

            setStatus("QR detectado");
            interpretarQR(result.getText());
          }

          // ℹ️ error es normal cuando no hay QR
        },
      )
      .then((controls) => {
        controlsRef.current = controls;
        setStatus("Apunta la cámara al código QR");
      })
      .catch((err) => {
        toast.error("❌ Error cámara:", err);
        setStatus("No se pudo acceder a la cámara");
      });

    return () => {
      if (controlsRef.current) {
        controlsRef.current.stop();
      }
    };
  }, [interpretarQR]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="container mx-auto px-4 py-6 pt-20 md:pt-28">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="max-w-xl mx-auto"
        >
          <Card>
            <CardContent className="p-4 text-center space-y-3">
              <h2 className="text-xl font-semibold">Escanear código QR</h2>

              <p className="text-sm text-gray-600">{status}</p>

              <video
                ref={videoRef}
                className="w-full rounded-lg border"
                muted
                playsInline
              />

              <p className="text-xs text-gray-400">
                Asegúrate de que el QR esté bien iluminado
              </p>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>
  );
}
